export const getTelephoneNumberWithDash = (telephoneNumber: string) => {
  if (telephoneNumber.length < 4) return telephoneNumber;
  else if (telephoneNumber.length < 8) return `${telephoneNumber.substring(0, 3)}-${telephoneNumber.substring(3, 7)}`
  else return `${telephoneNumber.substring(0, 3)}-${telephoneNumber.substring(3, 7)}-${telephoneNumber.substring(7, 11)}`
}